import { Series } from '@goldcast/api/backend';

import { State } from './types';

const getters = {
  getSeriesList(state: State): Array<Series> {
    return Object.values(state.seriesList || {});
  },
  getCurrentSeriesById: (state: State) => (seriesId: string) => {
    if (seriesId && state.seriesList[seriesId]) {
      return state.seriesList[seriesId];
    }
    return null;
  }
};

export default getters;
